import { toEDNString } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { ServiceAccount } from "../types/serviceAccount";

const DS = `(datastore Qo.Api.Bl "omega/query-omega/api/block")`;

// Polymorphic single-object getter (U.13): Qo.Api.Bl/get-data-by-id
// AppId PageId BlockId Object — resolves the block, then returns the linked
// object (the SA, incl. service-account-spec.name + api-key).
export const getServiceAccount: (config: {
  "app-id": string;
  "page-id": string;
  "block-id": string;
}) => Promise<ServiceAccount> = async (config) => {
  const appId = toEDNString(config["app-id"]);
  const pageId = toEDNString(config["page-id"]);
  const blockId = toEDNString(config["block-id"]);
  const query = `
        ${DS}
        (Qo.Api.Bl/get-data-by-id ${appId} ${pageId} ${blockId} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
